/**
 * Errores de autenticación del LMS.
 *
 * ⚠ DOS COSAS QUE HAY QUE HACER SIEMPRE JUNTAS:
 *  1. Un 403 con destino (mentoría sin aprobar, o sin acceso al entrar por SSO)
 *     trae un `detail` OBJETO `{code, message, redirect}`, no una cadena.
 *     Pintarlo tal cual reventaría el render ("Objects are not valid as a React
 *     child"), así que todo texto de error pasa por `errorText()`.
 *  2. Ese caso no es un error que se lee: es un desvío. `handleAccessRedirect()`
 *     manda al miembro al destino (Mi Cuenta) — SOLO cuando entra por SSO desde
 *     Mi Cuenta. El login DIRECTO del LMS no lo usa: se queda en su formulario
 *     con "No access to this tool" (decisión 2026-08-04).
 */

/** ¿El 403 trae un destino? Si lo trae, redirige y devuelve true. */
export function handleAccessRedirect(err) {
  const d = err?.response?.data?.detail;
  if (d && typeof d === 'object' && d.redirect) {
    window.location.replace(d.redirect);
    return true;
  }
  return false;
}

/** Texto legible de cualquier error de auth, venga como cadena o como objeto. */
export function errorText(err, fallback) {
  const d = err?.response?.data?.detail;
  if (typeof d === 'string' && d) return d;
  if (d && typeof d === 'object' && d.message) return d.message;
  return fallback;
}
